// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1OK4Q","label":"CategoryService_label__kMHhX","location":"CategoryService_location___kXfz"};